import { NotificationsRepository } from '../../domain/repositories/notifications.repository ';
import { notificationsRepository } from '../repositories/notifications.respository';

export const notificationsRepositoryInstance: NotificationsRepository = notificationsRepository();
